import { TreeNode } from "primeng/api";
import { Subscription } from "rxjs";
import { CollectionInfo } from "src/app/common/components/collections-multi-select/collections-multi-select.component";
import { FileInfo } from "src/app/common/components/file-content-list/file-content-list.component";
import { DragAndDropItem } from "src/app/common/models/drag-and-drop-item.model";
import { SavedChat } from "src/app/modules/prompts/models/backend-saved-chat.model";
import { PredefinedPrompt } from "src/app/modules/prompts/models/prompt-template.model";

export class AssistantData {
  isFloating;
  isDocked;

  selectedPrompt?: TreeNode<PredefinedPrompt>;
  streamSubscribtion?: Subscription;
  temperature = 0.5;
  savedChat: SavedChat = {
    id: crypto.randomUUID(),
    messages: [],
    createdAt: new Date().toISOString(),
    temperature: 0.5,
    model: "",
    promptId: undefined,
  };
  searchGrounding = false;
  lastPromptId?: string | null = null; // used to track the last prompt used
  contextFiles: FileInfo[] = [];
  collections: CollectionInfo[] = []; // collections for RAG search
  collectionDateFrom?: string | null = null;
  collectionDateTo?: string | null = null;
  userInput = "";
  genPending = false;
  summaryReport = "";
  disableScrolling = false;
  currentScrollPosition: number | null = null;

  initialContextData: DragAndDropItem | null = null; // init context with media data

  constructor(isFloating = false, isDocked = false) {
    this.isFloating = isFloating;
    this.isDocked = isDocked;
  }
}
